export default "__VITE_ASSET__13453225__"